import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaCloud, FaSyncAlt } from 'react-icons/fa';
import { getRekognitionIndexStatus, indexEventRekognition } from '../services/api';
import './AwsIndexPanel.css';

export default function AwsIndexPanel({ eventId, photoCount, enabled }) {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [actionError, setActionError] = useState('');
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    let active = true;
    let timer;
    setStatus(null);
    const refresh = async () => {
      try {
        const result = await getRekognitionIndexStatus(eventId);
        if (!active) return;
        setStatus(result);
        setError('');
        if (result.configured && result.selfie_search_enabled && result.pending_photos > 0) {
          timer = setTimeout(refresh, 10000);
        }
      } catch (err) {
        if (active) setError(err.message || "Impossible de vérifier l'indexation AWS.");
      }
    };
    refresh();
    return () => { active = false; clearTimeout(timer); };
  }, [eventId, photoCount, enabled, revision]);

  const start = async () => {
    if (busy) return;
    setBusy(true);
    setActionError('');
    try {
      await indexEventRekognition(eventId);
    } catch (err) {
      setActionError(err.message || "L'indexation a échoué. Vérifiez le statut avant de réessayer.");
    } finally {
      setBusy(false);
      setRevision(value => value + 1);
    }
  };

  const complete = status?.index_complete;
  const label = busy ? 'Indexation AWS en cours…' : !status ? 'Vérification de l’indexation…'
    : !status.configured ? 'AWS non configuré' : !enabled ? 'Recherche par selfie désactivée'
      : !status.total_photos ? 'Aucune photo à indexer' : complete ? 'Indexation AWS terminée' : 'Indexation AWS à compléter';
  return (
    <section className={`aws-index-panel${complete ? ' aws-index-complete' : ''}`} aria-label="Indexation AWS">
      <div className="aws-index-icon" aria-hidden="true">{complete ? <FaCheckCircle /> : <FaCloud />}</div>
      <div className="aws-index-body">
        <strong role="status" aria-live="polite">{label}</strong>
        {status && <p>{status.indexed_photos} / {status.total_photos} photos analysées par AWS Rekognition.</p>}
        {busy && <p>Gardez cette page ouverte. Les photos déjà indexées sont conservées.</p>}
        {!!error && <p role="alert" className="aws-index-error">{error}</p>}
        {!!actionError && <p role="alert" className="aws-index-error">{actionError}</p>}
      </div>
      <div className="aws-index-actions">
        <button type="button" onClick={() => setRevision(value => value + 1)} disabled={busy} aria-label="Actualiser le statut AWS"><FaSyncAlt /></button>
        <button type="button" onClick={start} disabled={busy || !status?.configured || !enabled || !status?.pending_photos}>
          {busy ? 'Indexation…' : complete ? 'Indexation terminée' : 'Lancer l’indexation AWS'}
        </button>
      </div>
    </section>
  );
}
